import apiClient from './apiClient';

const leaveService = {
  /**
   * Get all leave requests with optional filters
   */
  getAll: async (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams({
      page,
      limit,
      ...filters
    });
    const response = await apiClient.get(`/leaves?${params}`);
    return response.data;
  },

  /**
   * Get pending leaves for manager's team
   */
  getPendingForManager: async (page = 1, limit = 10, status = 'Pending') => {
    const params = new URLSearchParams({
      page,
      limit,
      status
    });
    const response = await apiClient.get(`/leaves/pending/manager?${params}`);
    return response.data;
  },

  /**
   * Check if current user has team members
   */
  hasTeam: async () => {
    const response = await apiClient.get('/leaves/team/has-team');
    return response.data;
  },

  /**
   * Apply for leave
   */
  apply: async (leaveData) => {
    const response = await apiClient.post('/leaves', leaveData);
    return response.data;
  },

  /**
   * Get leave details
   */
  getById: async (id) => {
    const response = await apiClient.get(`/leaves/${id}`);
    return response.data;
  },

  /**
   * Approve leave
   */
  approve: async (id, comments) => {
    const response = await apiClient.put(`/leaves/${id}/approve`, { comments });
    return response.data;
  },

  /**
   * Reject leave
   */
  reject: async (id, comments) => {
    const response = await apiClient.put(`/leaves/${id}/reject`, { comments });
    return response.data;
  },

  /**
   * Get employee leave balance
   */
  getLeaveBalance: async (employeeId) => {
    const response = await apiClient.get(`/leaves/balance/${employeeId}`);
    return response.data;
  }
};

export default leaveService;
